import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class UserIdsTokenService {

  constructor(private api: ApiService) { }

  /**
   * Posts a list of userIds to get a token when the list is too large
   * @param userIds Array of user IDs to be tokenized
   * @param companyId Current company ID
   * @returns Observable with the response containing userIdsToken
   */
  getUserIdsToken(userIds: string[], companyId: string): Observable<{ userIdsToken: string }> {
    return this.api.request('post', `scorecard-bigquery/userIds`, {
      userIds,
    }, {
      params: {
        company: companyId,
      },
    });
  }
}
